import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import NoPlanIcon from "@components/Icons/NoPlanIcon";

const useStyles = makeStyles()({
  lightColor: {
    color: "rgba(125, 135, 151, 0.7)",
  },
});

const StyledNoPlanIcon = withStyles(NoPlanIcon, {
  root: {
    height: "76px",
    width: "76px",
  },
});

const RecipesEmptyView: React.FC = () => {
  const { classes } = useStyles();
  return (
    <Box
      height={"100%"}
      width={"100%"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
    >
      <StyledNoPlanIcon />
      <Typography className={classes.lightColor} variant="h5">
        No recipes yet
      </Typography>
    </Box>
  );
};

export default RecipesEmptyView;
